import { Checkbox, makeStyles, Option, OptionGroup, OptionOnSelectData } from '@fluentui/react-components';
import { observer } from 'mobx-react-lite';
import React, { useMemo } from 'react';
import { SelectOptions } from '../form/SelectOptions';
import { DropdownOption } from '../../../models';

interface Props {
  label: string;
  designations: DropdownOption<string>[],
  selectedDesignationCodes: string[];
  allDesignationCheckedText: string,
  onDesignationsChange: (updatedDesignations: string[]) => void;
}

const useStyles = makeStyles({
  allCheckOption: { padding: 0 },
  allCheckCheckboxLabel: { color: '#242424' },
  option: { paddingLeft: '36px' },
});

const AssignDesignationsImpl: React.FC<Props> = props => {
  const {
    label,
    allDesignationCheckedText,
    designations,
    selectedDesignationCodes,
    onDesignationsChange,
  } = props;

  const styles = useStyles();

  const selectedDesignations = useMemo(() => {
    return designations.reduce((acc, designation) => {
      if (selectedDesignationCodes.includes(designation.value)) {
        acc.push(designation);
      }
      return acc;
    }, [] as DropdownOption<string>[])

  }, [selectedDesignationCodes.join(), designations.join()]);

  const allDesignationChecked: boolean | 'mixed' = useMemo(() => {
    if (selectedDesignations.length === designations.length) return true;
    if (selectedDesignations.length > 0) return 'mixed';
    return false;
  }, [selectedDesignations.join(), designations.join()])

  const onSelectingOptions = (data: OptionOnSelectData) => {
    if (data.optionValue !== 'All') return onDesignationsChange(data.selectedOptions);
    if (allDesignationChecked === true) return onDesignationsChange([]);

    return onDesignationsChange(designations.map((designation) => designation.value));
  };

  return (
    <div className='assign-designations'>
      <SelectOptions
        label={label}
        onOptionSelect={onSelectingOptions}
        dropdownProps={{
          multiselect: true,
          inlinePopup: true,
          value: allDesignationChecked === true
            ? allDesignationCheckedText
            : selectedDesignations.map((designation) => designation.text).join(', '),
          selectedOptions: selectedDesignations.map((designation) => designation.value),
        }}
      >
        <OptionGroup>
          <Option
            text={allDesignationCheckedText}
            value='All'
            checkIcon={null}
            className={styles.allCheckOption}
          >
            <Checkbox
              checked={allDesignationChecked}
              label={{
                children: allDesignationCheckedText,
                className: styles.allCheckCheckboxLabel,
              }}
            />
          </Option>
          {
            designations.map((designation) => (
              <Option
                key={designation.value}
                value={designation.value}
                className={styles.option}
              >
                {designation.text}
              </Option>
            ))
          }
        </OptionGroup>
      </SelectOptions>
    </div>
  );
}

export const AssignDesignations = observer(AssignDesignationsImpl);
